<template>
  <div :class="className" :style="{ height: height, width: width }"></div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons");
import resize from "./mixins/resize";

export default {
  name: "LineChart",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "350px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartInfo: {
      type: Object,
      default: () => ({})
    },
    // ✅ 核心：chartData 包含多个 series 和 xAxis 数据
    chartData: {
      type: Object,
      required: true
      // 结构见下方说明
    },
    // 可选：备用 xAxis 标签
    chartdate: {
      type: Object,
      default: () => ({
        chartdatelist: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"]
      })
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.setOptions(val);
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) return;
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions(data = {}) {
      console.log('line',data);
      // 🔽 提取数据
      const seriesList = data.series || []; // 动态系列数组
      const xAxisData = data.xAxis || this.chartdate?.chartdatelist || ["1月", "2月", "3月", "4月", "5月", "6月", "7月"];

      // 🌈 如果没有传 series，默认显示两条示例线
      const hasSeries = Array.isArray(seriesList) && seriesList.length > 0;

      const defaultSeries = [
        { name: "生产数量", data: [80, 120, 90, 150, 130, 180, 160] },
        { name: "计划数量", data: [100, 100, 120, 140, 160, 170, 190] }
      ];

      const finalSeries = hasSeries ? seriesList : defaultSeries;

      // 自动生成 legend 名称
      const legendData = finalSeries.map(s => s.name);

      // 图表标题
      const titleText = this.chartInfo?.title || "多系列折线图";

      // 设置 ECharts 选项
      this.chart.setOption({
        title: {
          show: true,
          text: titleText,
          left:'center',
          textStyle: {
            color: "#333",
            fontWeight: "bolder"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          padding: [5, 10]
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          boundaryGap: true,
          axisTick: { show: true }
        },
        yAxis: {
          type: "value",
          axisTick: { show: true }
        },
        legend: {
            data: legendData, // 动态生成的数据
            right: '10%', // 设置图例距离右侧的距离
            top: 'top', // 可以设置为 'auto', 'top', 'middle', 'bottom' 或者具体的像素值
            orient: 'horizontal' // 图例列表的布局朝向，默认水平（'horizontal'），可以设置为垂直
        },
        series: finalSeries.map((item, index) => {
          // 为每条线设置样式（可扩展颜色列表）
          const colors = ["#3888fa", "#ff6f61", "#40c057", "#fd7e14", "#6f42c1"];
          const areaColors = ["#f3f8ff", "#fff5f5", "#f8fff5", "#fff9f0", "#f8f5ff"];
          const color = colors[index % colors.length];
          const areaColor = areaColors[index % areaColors.length];

          return {
            name: item.name,
            type: "line",
            data: item.data,
            smooth: true,
            itemStyle: {
              normal: {
                color: color,
                lineStyle: {
                  color: color,
                  width: 2
                },
                areaStyle: {
                  color: areaColor
                }
              }
            },
            animationDuration: 2800,
            animationEasing: "cubicInOut"
          };
        })
      });
    }
  }
};
</script>

<style scoped>
.chart {
  /* 可选 */
}
</style>
